import React, { useRef, useState } from "react";
import UploadGuide from "./UploadGuide";
import { whoIsAthleteCoach } from "../../../../utils/user-helpers";

const Guides = ({
  athlete,
  referAsClients,
  coachOrganizationInformation = undefined,
  activeUser,
}) => {
  const { _id: athleteId } = athlete;

  const userToRequest =
    !!coachOrganizationInformation &&
    String(
      whoIsAthleteCoach(
        activeUser.athletes,
        athleteId,
        activeUser._id,
        coachOrganizationInformation._id
      )
    ) !== String(activeUser._id)
      ? coachOrganizationInformation._id
      : activeUser._id;

  const [canSubmit, setCanSubmit] = useState(false);

  const mealInputRef = useRef(null);
  const supplementInputRef = useRef(null);

  const handleBeforeSubmit = () => {
    if (mealInputRef.current.value) {
      mealInputRef.current.disabled = false;
    }

    if (supplementInputRef.current.value) {
      supplementInputRef.current.disabled = false;
    }
  };
  const handleAfterSubmit = () => {
    setTimeout(() => {
      // Check input values using refs before disabling
      if (mealInputRef.current.value) {
        mealInputRef.current.disabled = true;
      }

      if (supplementInputRef.current.value) {
        supplementInputRef.current.disabled = true;
      }
    }, 200);
  };

  return (
    <div role="guides-wrapper">
      <header>
        <h4>Guides</h4>
        <p className="p5">
          {`Upload guides for your ${
            referAsClients ? "client's" : "athlete's"
          } to follow`}
        </p>
      </header>
      <form
        encType="multipart/form-data"
        method="POST"
        data-noreset
        action={`/actions/guides/save`}
        onSubmit={handleAfterSubmit}
      >
        <input type="hidden" name="athleteId" value={athleteId} />
        <div>
          <article>
            <p className="p4">Upload Meal Plan</p>
            <UploadGuide
              name="meal-file"
              prefix=""
              setcansubmit={setCanSubmit}
              inputRef={mealInputRef}
              athlete={athlete}
              field="meal"
              coachOrganizationInformation={coachOrganizationInformation}
              activeUser={activeUser}
            />
          </article>
          <article>
            <p className="p4">Upload Supplement Guide</p>
            <UploadGuide
              name="supplement-file"
              prefix=""
              setcansubmit={setCanSubmit}
              inputRef={supplementInputRef}
              athlete={athlete}
              field="supplement"
              coachOrganizationInformation={coachOrganizationInformation}
              activeUser={activeUser}
            />
          </article>
          <input
            name="userToRequest"
            id="userToRequest"
            defaultValue={userToRequest}
            style={{ display: "none" }}
          ></input>
        </div>

        <footer>
          {/* <div className="chip success"> */}
            <a href="/coaching-portal/msb-university?product=pull" className="chip success">
              NEW - Learn more about our in-app meal planner
            </a>
          {/* </div> */}
          <button
            onClick={handleBeforeSubmit}
            disabled={!canSubmit}
            data-button-type="primary"
          >
            Save
          </button>
        </footer>
      </form>
    </div>
  );
};

module.exports = Guides;
